export const validateOverview = ({overview, error}) => !!(overview && !error);

export const validateDescription = ({description, error}) => !!(description && !error);

export const validateFaq = ({faq, error}) => !!(faq && faq.questionsAndAnswers && faq.questionsAndAnswers.length && !error);

export const validateReviews = ({reviews, error}) => !!(reviews && reviews.reviews && reviews.reviews.length && !error);

export const validateOrderDetails = ({isSinglePackage, error}) => !!(isSinglePackage && !error);

export const validatePackagesTable = ({isTriplePackage, error}) => !!(isTriplePackage && !error);

export const validateSellerCard = ({sellerCard, error}) => !!(sellerCard && !error);
